import './App.css';
import React, {useState,useEffect} from "react";
import {BrowserRouter as Router, Routes, Route, Navigate} from 'react-router';
import Header from "./components/common/pnet-header/Header";
import Footer from "./components/common/pnet-footer/Footer";
import ForgotPasswordAuthenticate from './pages/ForgotPasswordFlow/ForgotPasswordAuthenticate';
import ForgotPasswordTwoStepVerification from './pages/ForgotPasswordFlow/ForgotPasswordTwoStepVerification';
import RegisterComputerVerify from './pages/RegisterComputerFlow/RegisterComputerVerify';
import RegisterComputerRegistrationOptions from './pages/RegisterComputerFlow/RegisterComputerRegistrationOptions';
import RegisterComputerComplete from './pages/RegisterComputerFlow/RegisterComputerComplete';
import FirstTimeLogInSetup from "./pages/FirstTimeLogInSetupFlow/FirstTimeLogInSetup";
import FirstTimeLogInSetupRegisterComputer from "./pages/FirstTimeLogInSetupFlow/FirstTimeLogInSetupRegisterComputer";
import {TargetRedirectComponent} from "./pages/TargetRedirect/TargetRedirectComponent.tsx";
import FirstTimeLogInSetupComplete from "./pages/FirstTimeLogInSetupFlow/FirstTimeLogInSetupComplete";
import IndexPageComponent from "./pages/indexPage/IndexPageComponent";
import {Card, FlexItem, FlexLayout, Scrim} from "@salt-ds/core";
import HomePageComponent from "./pages/HomePageComponent";
import ForgotUserOrOrgIdEmail from './pages/ForgotUserOrOrgIdFlow/ForgotUserOrOrgIdEmail';
import ForgotUserOrOrgIdComplete from './pages/ForgotUserOrOrgIdFlow/ForgotUserOrOrgIdComplete';
import ForgotPasswordComplete from './pages/ForgotPasswordFlow/ForgotPasswordComplete';
import ForgotPasswordSuccess from './pages/ForgotPasswordFlow/ForgotPasswordSuccess';
import OnlineProfileRegistrationAuthenticate
  from './pages/OnlineProfileRegistration/OnlineProfileRegistrationAuthenticate';
import OnlineProfileRegistrationCreateUserId
  from './pages/OnlineProfileRegistration/OnlineProfileRegistrationCreateUserId';
import OnlineProfileRegistrationReceivePassword
  from './pages/OnlineProfileRegistration/OnlineProfileRegistrationReceivePassword';
import ForgotUserOrOrgIdCard from './pages/ForgotUserOrOrgIdFlow/ForgotUserOrOrgIdCard';
import ForcedChangePasswordPage from "./pages/ForceChangePasswordFlow/ForceChangePasswordPage";
import ChangeExpiringPasswordPage from "./pages/ExpiringPasswordChangeFlow/ChangeExpiringPasswordPage";
import useSessionTimeout from "./common/sessionTimeout";
import OnlineProfileRegistrationCompleted from './pages/OnlineProfileRegistration/OnlineProfileRegistrationCompleted';
import OutageSystemMaintainance from './pages/SystemMaintainance/OutageSystemMaintainance';
import {index} from './api/LoginApi';
function App() {
  let basename = "/auth/public/app";

  const [showScrim, setShowScrim] = React.useState(false);
  const [modelContent, setModalContent] = React.useState();
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
  const [isUnplannedMaintenanceMode, setIsUnplannedMaintenanceMode] = useState(false);

  const fillAndOpenModel = (content) => {
    setModalContent(prevState => content)
    setShowScrim(prevState => true);
  }

  const closeAndClearModal = () => {
    setModalContent(prevState => null);
    setShowScrim(prevState => false);
  }

  const handleMaintenanceMode = (status) => {
    if (status === "maintenance") {

      sessionStorage.setItem('maintenanceMode', 'true');
      setIsMaintenanceMode(true);
    } else if (status === "unplanned-maintenance") {

      sessionStorage.setItem('unplannedMaintenanceMode', 'true');
      setIsUnplannedMaintenanceMode(true);
    } else {
      // No maintenance, no OIDC cookie
      sessionStorage.setItem('maintenanceMode', 'false');
    }
  };

  const handleOidc = async () => {
    // OIDC cookie exists, need to log out
    try {
      await fetch('/card/logoff', {
        method: 'GET',
        credentials: 'include'
      });
      window.location.reload();
      return; // Exit early to prevent further processing
    } catch (logoffError) {
      console.error('Error during logoff:', logoffError);
    }
  };


  // Check maintenance status and OIDC cookie on app initialization
  useEffect(() => {
    const checkMaintenanceAndOidc = async () => {
      // Check if we already have maintenance status in session
      const storedStatus = sessionStorage.getItem('maintenanceMode');

      if (storedStatus === null) {
        try {
          // Call the backend endpoint that checks both maintenance and OIDC
          const response = await index();
          if (response.data === "oidc") {
            await handleOidc();
            return;
          }
          handleMaintenanceMode(response.data);
        } catch (error) {
          // If error status is 400 and response contains maintenance
          if (error.response && error.response.status === 400 && error.response.data === "maintenance") {
            handleMaintenanceMode("maintenance");
          } else {
            console.error('Error checking app status:', error);
            sessionStorage.setItem('maintenanceMode', 'false');
          }
        }
      } else {
        // Use stored maintenance mode status
        setIsMaintenanceMode(storedStatus === 'true');
      }
    };
    checkMaintenanceAndOidc();
  }, []);

  return (<>

        <Router basename={basename}>
          <FlexLayout className={"app"}>
            <Scrim fixed open={showScrim}>
              <Card className={"modal"}>
                {modelContent}
              </Card>
            </Scrim>
            <FlexItem className={"header"}>
              <Header data-testid="header"/>
            </FlexItem>
            <FlexItem className={"content"}>
              <SessionTimeoutHandler data-testid="session-timeout-handler" />
              <Routes>
                {isMaintenanceMode ? (
                    <>
                      <Route path="/outage" element={<OutageSystemMaintainance maintenanceType="planned"/>} />
                      <Route path="*" element={<Navigate to="/outage" replace />} />
                    </>
                ) : isUnplannedMaintenanceMode ? (
                    <>
                      <Route path="/outage" element={<OutageSystemMaintainance maintenanceType="unplanned"/>} />
                      <Route path="*" element={<Navigate to="/outage" replace />} />
                    </>
                ) : (
                    <>
                      <Route path="/homePage" element={<HomePageComponent />} />
                      <Route path="/" element={<IndexPageComponent closeAndClearModal={closeAndClearModal}
                                                                   fillAndOpenModel={fillAndOpenModel} />} />
                      <Route path={"/changeExpiringPassword"} element={<ChangeExpiringPasswordPage />} />
                      <Route path="/forgotPassword" element={<ForgotPasswordAuthenticate />} />
                      <Route path="/forgotPasswordProvideAccessCode" element={<ForgotPasswordTwoStepVerification />} />
                      <Route path="/forgotPasswordComplete" element={<ForgotPasswordComplete />} />
                      <Route path="/forgotPasswordSuccess" element={<ForgotPasswordSuccess closeAndClearModal={closeAndClearModal} fillAndOpenModel={fillAndOpenModel}/>} />
                      <Route path="/forgotUserOrOrgIdEmail" element={<ForgotUserOrOrgIdEmail />} />
                      <Route path="/forgotUserOrOrgIdComplete" element={<ForgotUserOrOrgIdComplete />} />
                      <Route path="/forceChangePassword" element={<ForcedChangePasswordPage />} />
                      <Route path="/forgotUserOrOrgIdCard" element={<ForgotUserOrOrgIdCard />} />
                      <Route path="/registerComputer" element={<RegisterComputerVerify />} />
                      <Route path="/registerComputerOptions" element={<RegisterComputerRegistrationOptions />} />
                      <Route path="/registerComputerComplete" element={<RegisterComputerComplete closeAndClearModal={closeAndClearModal} fillAndOpenModel={fillAndOpenModel}/>} />
                      <Route path="/firstTimeLogInSetup" element={<FirstTimeLogInSetup />} />
                      <Route path="/firstTimeLogInSetupRegisterComputer" element={<FirstTimeLogInSetupRegisterComputer />} />
                      <Route path="/firstTimeLogInSetupComplete" element={<FirstTimeLogInSetupComplete closeAndClearModal={closeAndClearModal} fillAndOpenModel={fillAndOpenModel}/>} />
                      <Route path="/profileRegistration" element={<OnlineProfileRegistrationAuthenticate />} />
                      <Route path="/profileRegistrationCreateUserId" element={<OnlineProfileRegistrationCreateUserId />} />
                      <Route path="/profileRegistrationReceivePassword"
                             element={<OnlineProfileRegistrationReceivePassword />} />
                      <Route path="/profileRegistrationCompleted" element={<OnlineProfileRegistrationCompleted />} />
                      <Route path="/targetRedirect" element={<TargetRedirectComponent />} />
                      <Route path="/outage" element={<Navigate to="/" replace />} />
                      {/* TODO: [S1192] Consider extracting "/" as a constant to avoid string duplication */}
                      <Route path="*" element={<Navigate to="/" replace />} />
                    </>
                )}
              </Routes>
            </FlexItem>
            <FlexItem>
              <Footer data-testid="footer"/>
            </FlexItem>
          </FlexLayout>

        </Router>

      </>
  );
}


function SessionTimeoutHandler() {
  useSessionTimeout();
  return null;
}

export default App;
